import { daysFromNow } from '@/lib/time'
import type { ListingFilters, PublicListing } from '@/lib/types/listing'

/**
 * Placeholder feed while GET /api/listings is empty.
 * Dropped as soon as the API returns at least one live listing.
 */

export const sampleDrops: PublicListing[] = [
  {
    id: '5b2e8f10-0000-4000-8000-000000000001',
    type: 'referral',
    brand: 'TechHaven',
    category: 'Electronics',
    country: null,
    benefitClaim: 'Get $50 off your first order over $200.',
    benefitClaimStatus: 'pending',
    expiresAt: daysFromNow(5),
    daysLeft: 5,
    posterUsername: 'mira',
    claimCount: 12,
    reportCount: 0,
  },
  {
    id: '5b2e8f10-0000-4000-8000-000000000002',
    type: 'discount',
    brand: 'FitLife Plus',
    category: 'Health & Wellness',
    country: null,
    benefitClaim: '20% off an annual subscription.',
    benefitClaimStatus: 'none',
    expiresAt: daysFromNow(1),
    daysLeft: 1,
    posterUsername: 'jordan',
    claimCount: 4,
    reportCount: 1,
  },
  {
    id: '5b2e8f10-0000-4000-8000-000000000003',
    type: 'referral',
    brand: 'DevTools Pro',
    category: 'Software',
    country: null,
    benefitClaim: 'One month free on any premium tier plan.',
    benefitClaimStatus: 'pending',
    expiresAt: daysFromNow(12),
    daysLeft: 12,
    posterUsername: 'devlin',
    claimCount: 31,
    reportCount: 0,
  },
  {
    id: '5b2e8f10-0000-4000-8000-000000000004',
    type: 'discount',
    brand: 'Northlight UI',
    category: 'Design',
    country: 'US',
    benefitClaim: '50% off the component library launch bundle.',
    benefitClaimStatus: 'none',
    expiresAt: daysFromNow(3),
    daysLeft: 3,
    posterUsername: 'sasha',
    claimCount: 8,
    reportCount: 0,
  },
  {
    id: '5b2e8f10-0000-4000-8000-000000000005',
    type: 'discount',
    brand: 'Ambient Audio Co.',
    category: 'Music & Audio',
    country: null,
    benefitClaim: 'Royalty-free soundscapes pack, 30% off for creators.',
    benefitClaimStatus: 'none',
    expiresAt: daysFromNow(18),
    daysLeft: 18,
    posterUsername: 'nori',
    claimCount: 2,
    reportCount: 0,
  },
  {
    id: '5b2e8f10-0000-4000-8000-000000000006',
    type: 'referral',
    brand: 'Ridewell',
    category: 'Travel',
    country: 'GB',
    benefitClaim: '£15 credit after your first booking.',
    benefitClaimStatus: 'pending',
    expiresAt: daysFromNow(9),
    daysLeft: 9,
    posterUsername: 'cale',
    claimCount: 19,
    reportCount: 2,
  },
]

export function filterSampleDrops(
  filters: ListingFilters = {},
): PublicListing[] {
  const q = filters.q?.trim().toLowerCase()
  return sampleDrops.filter((drop) => {
    if (filters.type && drop.type !== filters.type) {
      return false
    }
    if (q && !drop.brand.toLowerCase().includes(q)) {
      return false
    }
    if (filters.category && drop.category !== filters.category) {
      return false
    }
    // `country: null` means the poster didn't say — never matches a filter.
    if (filters.country && drop.country !== filters.country) {
      return false
    }
    return true
  })
}
